// @flow

import ViewUtil from '../ViewUtil';
import Store from "../store/Store";
import {ASSET_LIST_BLOCK_INSTANCE} from "../store/Constants";
import System from '../basic/System';
import { isMobile } from './ScreenUtil';

export function useWavePlayer() {
  const args = window.ARGS || {};
  return !!args.wp;
}

export function useNewImagePreview() {
  const args = window.ARGS || {};
  return args.scale !== 'false';
}

export function isPublicView() {
  const args = window.ARGS || {};
  return args.public === 'true';
}

export function showReportingTab() {
  const args = window.ARGS || {};
  return args.rpt === 'true';
}

export function canShowAssetsTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowBrowseExtTab() {
  return !System.isDesktop() && canShowAssetsTab() && !isMobile();
}

export function canShowCollectionsTab() {
  return (
    !window.gs.linkSharingData &&
    //window.gs.isExternalUser &&
    //!window.gs.isNoRoleUser &&
    !ViewUtil.isDirectLinkToCollection()
  );
}

export function canShowSearchTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowHomeTab() {
  return !window.gs.linkSharingData && !window.gs.isExternalUser && !window.gs.isNoRoleUser;
}

export function canShowVideoTimeline() {
  return window.ARGS.ai !== 'false';
}
